/**
 * @file   src\components\DateRangeSelector.js
 * @brief  This file is responsible for date range selector for stay ads
 * @date   May, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CalendarIcon from "../images/black-calendar-icon.svg";
import TextBox from "./Common/TextBox";
import { formateDate } from "../helpers/common";
import { useState } from "react";

const DateRangeSelector = (props) => {
  const { startDate, endDate, setStartDate, setEndDate } = props;
  const [showCalendar, setShowCalendar] = useState(false);
  const [selectDate, setSelectDate] = useState("start");

  const onChange = (date) => {
    if (selectDate === "start") {
      setStartDate(date);
    }
    if (selectDate === "end") {
      setEndDate(date);
    }
    setShowCalendar(false);
  };

  const handleOnChange = (type) => {
    setShowCalendar(true);
    setSelectDate(type);
  };

  return (
    <>
      <div className="wantad-calendar-top position-relative">
        <ul className="wantadfilter-calendar-list">
          <li>
            <div className="input-group position-relative">
              <TextBox
                type="text"
                className="form-control"
                disabled={true}
                value={startDate ? formateDate(startDate, "mm/dd/yyyy") : ""}
              ></TextBox>
              <div
                className="wantad-calendar-icon"
                onClick={() => handleOnChange("start")}
                onKeyDown={() => handleOnChange("start")}
                role="button"
              >
                <img src={CalendarIcon} alt={CalendarIcon} className="" />
              </div>
            </div>
          </li>
          <li className="text-center">
            <span className="middle-separator">-</span>
          </li>
          <li>
            <div className="input-group position-relative">
              <TextBox
                type="text"
                disabled={true}
                className="form-control"
                value={endDate ? formateDate(endDate, "mm/dd/yyyy") : ""}
              ></TextBox>
              <div
                className="wantad-calendar-icon"
                onClick={() => handleOnChange("end")}
                onKeyDown={() => handleOnChange("end")}
                role="button"
              >
                <img src={CalendarIcon} alt={CalendarIcon} className="" />
              </div>
            </div>
          </li>
        </ul>
      </div>
      {showCalendar && (
        <DatePicker
          calendarStartDay={1}
          formatWeekDay={(nameOfDay) => nameOfDay.substr(0, 3)}
          selectsStart={selectDate === "start" ? true : false}
          selectsEnd={selectDate === "end" ? true : false}
          startDate={startDate && new Date(startDate)}
          endDate={endDate && new Date(endDate)}
          minDate={new Date()}
          inline
          monthsShown={1}
          onChange={onChange}
          disabledKeyboardNavigation
        />
      )}
    </>
  );
};

export default DateRangeSelector;
